import { UserProfile, UserWorkoutSession } from 'fitbeat.gym-core';
import moment from 'moment';
import React, { Component } from 'react';
import { CSVLink } from 'react-csv';
import { connect } from 'react-redux';
import ReactTable, { SortingRule } from 'react-table';
import { currentGymSelector } from '../../adminSettings/selector';
import { IAppStore } from '../../rootReducer';
import { Loading } from '../../shared/loading';
import {
  nextButton,
  previousButton,
} from '../components/reactTablePaginationButtons';
import { buildWorkoutConfigColumnsFromAccessor } from '../filters/workoutColumnConfigFilter';

interface IProps {
  memberWorkoutHistory: UserWorkoutSession[];
  sortOrder: SortingRule[];
  loading: boolean;
  workoutColumns: any;
  memberDetail: UserProfile;
}

class WorkoutHistoryOverviewTable extends Component<IProps, any> {
  public reactTable: any;
  constructor(props: IProps) {
    super(props);
    this.reactTable = React.createRef();
  }

  public render() {
    const { memberDetail } = this.props;
    return (this.props.loading ?
      <div className={'loader-container'}>
        <Loading />
      </div> :
      <div>
        <CSVLink
          data={this.props.memberWorkoutHistory || []}
          asyncOnClick
          filename={`${memberDetail.email}-workouts-${
            moment(new Date()).toISOString()
          }-table.csv`}
          target='_blank'
        >
          <button className='jr-btn-no-border black-color-text'>
            <img className='btnImg csvExportIconContainer' src='resources/images/csv-export-icon.svg' />
            CSV Export
          </button>
        </CSVLink>
        <ReactTable
          className='workout-history-overview-table'
          ref={this.reactTable}
          minRows={0}
          resizable={true}
          showPageSizeOptions={true}
          filterable
          data={
            this.props.memberWorkoutHistory ? this.props.memberWorkoutHistory : []
          }
          loadingText='Loading...'
          noDataText={'No data found'}
          columns={this.props.workoutColumns}
          defaultPageSize={10}
          defaultFilterMethod={(filter: any, row: any) =>
            String(row[filter.id]) === filter.value
          }
          defaultSorted={this.props.sortOrder}
          PreviousComponent={previousButton}
          NextComponent={nextButton}
        />
      </div>
    );
  }
}

const mapStateToProps = (state: IAppStore, props: any) => {
  const { accountActions, members } = state;
  const { memberWorkoutHistory } = accountActions.data;
  const { isFetching } = accountActions.view;
  const { memberAccountData } = members.data;
  const memberDetail = memberAccountData && memberAccountData.userInfo.profile;
  const currentGym = currentGymSelector(state);
  const workoutColumns = buildWorkoutConfigColumnsFromAccessor(currentGym);
  return {
    loading: isFetching,
    memberWorkoutHistory,
    workoutColumns,
    memberDetail,
  };
};

export default connect(mapStateToProps, null)(WorkoutHistoryOverviewTable);
